/**
 * /cloud-backup — migrated from public/js/cloud-backup.js.
 * 1. Switch button toggle pentru `.sum[data-id]` panels cu fade-in/fade-out animations.
 * 2. .layer-terms accordion (h2 click → slideToggle wrapper).
 */
import { Resort } from '../core/resort.js';

new Resort(() => {
    let switchReady = true;

    ($('header.c-backup .switch-btn') as Element | null)?.on('click', 'a', function (this: Element) {
        if (!switchReady) return;
        switchReady = false;
        if (this.classList.contains('active')) {
            switchReady = true;
            return;
        }
        ($('header.c-backup .switch-btn a.active') as Element | null)?.classList.remove('active');
        this.classList.add('active');

        const targetId = (this as HTMLElement).dataset['id'];

        $('.layer-1 .row .sum.active', (el: Element) => {
            el.classList.add('fade-out-fast');
            el.addEventListener('animationend', function (this: Element, e: Event) {
                e.stopPropagation();
                this.classList.remove('active', 'fade-out-fast');
                switchReady = true;
            }, { once: true });
            return true;
        });

        $(`.layer-1 .row .sum[data-id="${targetId}"]`, (el: Element) => {
            el.classList.add('active', 'fade-in-fast');
            el.addEventListener('animationend', function (this: Element, e: Event) {
                e.stopPropagation();
                this.classList.remove('fade-in-fast');
                switchReady = true;
            }, { once: true });
            return true;
        });
    });

    ($('.layer-terms') as Element | null)?.on('click', 'h2', function (this: Element) {
        this.classList.toggle('active');
        ($('.layer-terms .wrapper') as HTMLElement | null)?.slideToggle();
    });
});
